var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.show && _vm.fair ? _c('transition', {
    attrs: {
      "name": "modal",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "modal-container modal-container--scrollable"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__head"
  }, [_c('h1', {
    staticClass: "modal__title"
  }, [_c('span', [_vm._v("매칭상담회 기간 중 참여 가능한 스케줄을 설정해주세요")]), _c('small', [_vm._v("추후 수정을 원하실 경우 [마이페이지-매칭상담회-매칭스케줄]에서 수정을 부탁드립니다")])]), _c('button', {
    staticClass: "modal__close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/icon/close-rounded.png",
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "modal__body"
  }, [_c('matching-schedule', {
    attrs: {
      "fair": _vm.fair
    },
    on: {
      "save": _vm.save
    }
  })], 1), _c('div', {
    staticClass: "modal__foot"
  })])])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }